<template>
  <v-app>
    <div class="scrollable pkmn-background" />
    <v-main v-if="!hidden">
      <v-spacer />
        <v-row>
          <v-img
            max-width="600"
            width="100vw"
            :src="title"
          />
        </v-row>
        <v-banner>
          <v-row>
            <v-btn-toggle
              v-model="mainmenu"
              mandatory
            >
              <v-btn>
                About
              </v-btn>
              <v-btn>
                Development
              </v-btn>
              <v-btn>
                Quiz
              </v-btn>
            </v-btn-toggle>
          </v-row>
        </v-banner>
        <v-row>
          <About v-if="mainmenu === 0"/>
          <Development v-if="mainmenu === 1"/>
          <Quiz v-if="mainmenu === 2"/>
        </v-row>
      <v-spacer />
    </v-main>
    <a
      v-if="hidden"
      class="bottom-right-ish"
      href="https://twitter.com/the_rodraws"
    >
      @The_RoDraws
    </a>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          class="bottom-right"
          v-bind="attrs"
          v-on="on"
          @click="hidden = !hidden"
        >
          <v-icon>mdi-image</v-icon>
        </v-btn>
      </template>
      <span>View artwork</span>
    </v-tooltip>
  </v-app>
</template>

<script>
import About from '@/components/About'
import Quiz from '@/components/Quiz'
import Development from '@/components/Development'
export default {
  name: 'App',

  components: {
    About, Development, Quiz
  },

  data: () => ({
    mainmenu: 0,
    hidden: false,
    title: require('@/assets/titlev5.png')
  })
};
</script>

<style scoped>
* {
  margin: auto
}
.v-item--active {
  border-bottom: 2px solid black !important
}
.pkmn-background {
  background: url("assets/wanderlust.png") !important;
  background-attachment: local !important;
  background-repeat: no-repeat !important;
  height: 100vh;
  width: 100vw;
  position: fixed;
}

@media (max-width: 650px) {
  .pkmn-background {
    background-position: bottom -100px left 18% !important;
  }
}

.bottom-right {
  position: fixed;
  right: 0;
  bottom: 0
}

.bottom-right-ish {
  position: fixed;
  right: 40px;
  bottom: 5px;
  text-decoration: none;
  color: black;
}
</style>
